/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import tenants from '../tenant/ducks/index'
import users from '../users/ducks'
import onboardings from '../onboarding/ducks'
import settings from '../settings/ducks'
import metrics from '../metrics/ducks'
import { billingPlans } from '../billing/ducks'
import accessLogMetrics from '../metrics/ducks/accessLogMetrics'
import options from '../options/ducks'
import tiers from '../tier/ducks'

export default {
  tenants,
  tiers,
  users,
  onboardings,
  settings,
  metrics,
  billingPlans,
  accessLogMetrics,
  options,
}
